function getMapWindowFeatures() {
    const browserWindow = {
        x: window.screenX,
        y: window.screenY + (window.outerHeight - window.innerHeight),
        width: window.innerWidth,
        height: window.innerHeight,
    };

    const mapWindowWidth = browserWindow.width > 970
        ? browserWindow.width * 0.66
        : 640;
    const mapWindowHeight = browserWindow.height > 480
        ? browserWindow.height * 0.75
        : 360;

    const mapWindow = {
        width: mapWindowWidth,
        height: mapWindowHeight,
        top: browserWindow.y + ((browserWindow.height - mapWindowHeight) / 2),
        left: browserWindow.x + ((browserWindow.width - mapWindowWidth) * 0.75),
    };

    return Object.entries(mapWindow).map(([key, value]) => `${key}=${value}`).join(',');
}

export {
    getMapWindowFeatures,
};
